<template>
  <Catalogs
    title="Статусы откликов"
    create-text="Новый статус"
    :fetch-data="fetchData"
    :fields="fields"
    :route-create="'RecruitResponseStatusAdd'"
    :route-edit="'RecruitResponseStatusEdit'"
    :route-view="'RecruitResponseStatusView'"
    :route-path="'/recruit_response_statuses'"
    :can-edit="canEditRecruitResponseStatuses()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
import permissions, {PERM} from "../../../utilites/permissions";
import Catalogs from "../Catalogs.vue";

export default {
  name: "RecruitResponseStatuses",
  components: { Catalogs },
  mixins: [catalogs, permissions],
  data() {
    return {
      fields: [
        {
          key: 'id',
          sortable: true,
          class: 'recruit-response-status-id'
        },
        {
          key: 'name',
          label: 'Название',
          sortable: true,
        },
        {
          key: 'active',
          label: 'Активный',
          sortable: true,
          class: 'text-center'
        },
        {
          key: 'action',
          label: 'Действия',
          class: 'recruit-response-status-action'
        },
      ],
    };
  },
  methods: {
    async fetchData(data) {
      return await this.getRecruitResponseStatuses(data);
    },
    canEditRecruitResponseStatuses() {
      return this.hasPermission([PERM.CATALOG_RECRUIT_RESPONSE_STATUS_EDIT]);
    }
  }
}
</script>

<style>
.recruit-response-status-id {
  width: 60px;
  text-align: center;
}

.recruit-response-status-action {
  width: 80px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/RecruitResponseStatuses/RecruitResponseStatuses.vue